import styled from '@emotion/styled';

export const ToggleWrapper = styled.div<{ $isVisuallyAligned?: boolean }>`
  grid-area: one-way-toggle;
  padding-left: ${({ $isVisuallyAligned, theme }) =>
    $isVisuallyAligned ? theme.spacing[40] : ''};

  /* This is a workaround for the toggle to be visually aligned with the other controls in the form. */
  ${({ theme, $isVisuallyAligned }) => $isVisuallyAligned && theme.mq('lg')} {
    display: flex;
  }
`;
